import useTypedTranslation from '@hooks/useTypedTranslation'
import { formatCalendarDate } from '@utils/dates'

/** What a shelf without an observation in the window says: when it last had products, if ever. */
function NoDataText({ lastObservedAt }: { lastObservedAt?: string | null }) {
  const { t, i18n } = useTypedTranslation()

  if (!lastObservedAt) return t('storeMap.shelf.noProductsYet')

  return t('storeMap.shelf.lastWithProducts', { date: formatCalendarDate(new Date(lastObservedAt), i18n.language) })
}

export default NoDataText
